module.exports = __webpack_public_path__ + "assets/subdomain.e391b618.svg";